/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Case,
    CaseFromJSON,
    CaseToJSON,
    Party,
    PartyFromJSON,
    PartyToJSON,
} from '../models';

export interface CaseCreatePartyRequest {
    firmId: string;
    id: string;
    clientId: string;
    party?: Party;
}

export interface CaseGetRequest {
    firmId: string;
    id: string;
    clientId: string;
}

export interface CaseGetAllRequest {
    firmId: string;
    clientId: string;
    usersCasesOnly?: boolean;
    includeArchived?: boolean;
}

export interface CasePostRequest {
    firmId: string;
    clientId: string;
    _case?: Case;
}

export interface CasePutRequest {
    firmId: string;
    clientId: string;
    id: string;
    _case?: Case;
}

export interface CasePutPartyRequest {
    firmId: string;
    id: string;
    partyId: string;
    clientId: string;
    party?: Party;
}

/**
 * 
 */
export class CaseApi extends runtime.BaseAPI {

    /**
     */
    async caseCreatePartyRaw(requestParameters: CaseCreatePartyRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Party>> {
        if (requestParameters.firmId === null || requestParameters.firmId === undefined) {
            throw new runtime.RequiredError('firmId','Required parameter requestParameters.firmId was null or undefined when calling caseCreateParty.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling caseCreateParty.');
        }

        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId','Required parameter requestParameters.clientId was null or undefined when calling caseCreateParty.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Firm/{firmId}/Client/{clientId}/Case/{id}/Party`.replace(`{${"firmId"}}`, encodeURIComponent(String(requestParameters.firmId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PartyToJSON(requestParameters.party),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartyFromJSON(jsonValue));
    }

    /**
     */
    async caseCreateParty(requestParameters: CaseCreatePartyRequest, initOverrides?: RequestInit): Promise<Party> {
        const response = await this.caseCreatePartyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseGetRaw(requestParameters: CaseGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Case>> {
        if (requestParameters.firmId === null || requestParameters.firmId === undefined) {
            throw new runtime.RequiredError('firmId','Required parameter requestParameters.firmId was null or undefined when calling caseGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling caseGet.');
        }

        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId','Required parameter requestParameters.clientId was null or undefined when calling caseGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Firm/{firmId}/Client/{clientId}/Case/{id}`.replace(`{${"firmId"}}`, encodeURIComponent(String(requestParameters.firmId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseFromJSON(jsonValue));
    }

    /**
     */
    async caseGet(requestParameters: CaseGetRequest, initOverrides?: RequestInit): Promise<Case> {
        const response = await this.caseGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseGetAllRaw(requestParameters: CaseGetAllRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<Case>>> {
        if (requestParameters.firmId === null || requestParameters.firmId === undefined) {
            throw new runtime.RequiredError('firmId','Required parameter requestParameters.firmId was null or undefined when calling caseGetAll.');
        }

        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId','Required parameter requestParameters.clientId was null or undefined when calling caseGetAll.');
        }

        const queryParameters: any = {};

        if (requestParameters.usersCasesOnly !== undefined) {
            queryParameters['usersCasesOnly'] = requestParameters.usersCasesOnly;
        }

        if (requestParameters.includeArchived !== undefined) {
            queryParameters['includeArchived'] = requestParameters.includeArchived;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Firm/{firmId}/Client/{clientId}/Case`.replace(`{${"firmId"}}`, encodeURIComponent(String(requestParameters.firmId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CaseFromJSON));
    }

    /**
     */
    async caseGetAll(requestParameters: CaseGetAllRequest, initOverrides?: RequestInit): Promise<Array<Case>> {
        const response = await this.caseGetAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async casePostRaw(requestParameters: CasePostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Case>> {
        if (requestParameters.firmId === null || requestParameters.firmId === undefined) {
            throw new runtime.RequiredError('firmId','Required parameter requestParameters.firmId was null or undefined when calling casePost.');
        }

        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId','Required parameter requestParameters.clientId was null or undefined when calling casePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Firm/{firmId}/Client/{clientId}/Case`.replace(`{${"firmId"}}`, encodeURIComponent(String(requestParameters.firmId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CaseToJSON(requestParameters._case),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseFromJSON(jsonValue));
    }

    /**
     */
    async casePost(requestParameters: CasePostRequest, initOverrides?: RequestInit): Promise<Case> {
        const response = await this.casePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async casePutRaw(requestParameters: CasePutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.firmId === null || requestParameters.firmId === undefined) {
            throw new runtime.RequiredError('firmId','Required parameter requestParameters.firmId was null or undefined when calling casePut.');
        }

        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId','Required parameter requestParameters.clientId was null or undefined when calling casePut.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling casePut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Firm/{firmId}/Client/{clientId}/Case/{id}`.replace(`{${"firmId"}}`, encodeURIComponent(String(requestParameters.firmId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CaseToJSON(requestParameters._case),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async casePut(requestParameters: CasePutRequest, initOverrides?: RequestInit): Promise<void> {
        await this.casePutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async casePutPartyRaw(requestParameters: CasePutPartyRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Party>> {
        if (requestParameters.firmId === null || requestParameters.firmId === undefined) {
            throw new runtime.RequiredError('firmId','Required parameter requestParameters.firmId was null or undefined when calling casePutParty.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling casePutParty.');
        }

        if (requestParameters.partyId === null || requestParameters.partyId === undefined) {
            throw new runtime.RequiredError('partyId','Required parameter requestParameters.partyId was null or undefined when calling casePutParty.');
        }

        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId','Required parameter requestParameters.clientId was null or undefined when calling casePutParty.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Firm/{firmId}/Client/{clientId}/Case/{id}/Party/{partyId}`.replace(`{${"firmId"}}`, encodeURIComponent(String(requestParameters.firmId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"partyId"}}`, encodeURIComponent(String(requestParameters.partyId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PartyToJSON(requestParameters.party),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartyFromJSON(jsonValue));
    }

    /**
     */
    async casePutParty(requestParameters: CasePutPartyRequest, initOverrides?: RequestInit): Promise<Party> {
        const response = await this.casePutPartyRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
